/**
 * @desc 根据时间段获取月采购量
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.WeekRequest,
): Promise<defs.StandardReturn<Array<defs.PlanWeekMonthProcurementResponse>>> {
  return defHttp.post({
    url: '/web/plan/week/queryMonthProcurements',
    data,
  });
}

export function mock(
  data: defs.WeekRequest,
): Promise<defs.StandardReturn<Array<defs.PlanWeekMonthProcurementResponse>>> {
  return defHttp.post({
    url: '/mock/web/plan/week/queryMonthProcurements',
    data,
  });
}
